import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../contexts/halfYearContext";

import DataTable from "./BudgetListTable";
import MainTitle from "../../common/MainTitle";
import TableMainSearch from "../../common/MainSearch";
import MainBodyTabs from "../financeTabs";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";

const BudgetList = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);

  const routeTabs = [
    {
      name: "درآمد ها",
      path: "/mis/revenues/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/revenueBudgets",
    },
    {
      name: "تخفیف ها",
      path: "/mis/discounts",
    },
  ];

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `revenues/budget/accounts?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.Budgets} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainPrintLink path={"revenueBudgets"} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={routeTabs} {...props} />
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default BudgetList;
